import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button } from 'components/core/Button';
import { PhoneNumber } from 'components/contact/PhoneNumber';

import './clickToShowCallButton.scss';

function CallNumber({ phoneNumber, hideIcon }) {
	return (
		<PhoneNumber
			phoneNumber={phoneNumber}
			hideIcon={hideIcon}
			size="standard"
		/>
	);
}

CallNumber.propTypes = {
	phoneNumber: PropTypes.string,
	hideIcon: PropTypes.bool,
};

function CallButton({
	isShowingNumber,
	label,
	link,
	tel,
	_handleClick,
	dark,
	outline,
}) {
	return (
		<div className="click-to-show-call-button">
			{!isShowingNumber && (
				<Button
					className="deferred-call-now"
					dark={dark}
					outline={outline}
					link={link}
					onClick={_handleClick}
				>
					{label}
				</Button>
			)}
			<Button
				className={!isShowingNumber ? 'instant-call-now' : 'call-now'}
				dark={dark}
				outline={outline}
				link={link}
				href={tel}
				onClick={_handleClick}
				id="call-now-button"
			>
				{label}
			</Button>
		</div>
	);
}

CallButton.propTypes = {
	isShowingNumber: PropTypes.bool,
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	tel: PropTypes.string,
	link: PropTypes.bool,
	_handleClick: PropTypes.func,
	dark: PropTypes.bool,
	outline: PropTypes.bool,
};

function ClickToShowCallButton({
	phoneNumber,
	unformattedPhoneNumber,
	dark,
	hideIcon,
	asButton,
	initialLabel = 'Call facility',
	link,
	outline,
}) {
	const [isShowingNumber, setShowingNumber] = useState(false);

	const tel = `tel:${unformattedPhoneNumber}`;
	const label = isShowingNumber ? <CallNumber phoneNumber={phoneNumber} hideIcon={hideIcon} /> : initialLabel;

	const _handleClick = () => {
		if (!isShowingNumber) {
			setShowingNumber(true);
		}
	};

	if (isShowingNumber && !asButton) {
		return <CallNumber phoneNumber={phoneNumber} hideIcon={hideIcon} />;
	}

	return (
		<CallButton
			isShowingNumber={isShowingNumber}
			label={label}
			link={link}
			tel={tel}
			_handleClick={_handleClick}
			dark={dark}
			outline={outline}
		/>
	);
}

ClickToShowCallButton.propTypes = {
	/** The phone number to display - e.g. (888) 777-6666 */
	phoneNumber: PropTypes.string.isRequired,
	unformattedPhoneNumber: PropTypes.string.isRequired,
	dark: PropTypes.bool,
	hideIcon: PropTypes.bool,
	asButton: PropTypes.bool,
	initialLabel: PropTypes.string,
};

export default ClickToShowCallButton;
